class CompleteTheStyleTabs extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.tabs = this.els.tab?.elements
    this.panels = this.els.panel?.elements

    if (!this.tabs) return

    this.handleClick = this.handleClick.bind(this)
    document.addEventListener('click', this.handleClick)
  }

  handleClick (e) {
    const target =
      e.target.closest(this.els.tab.selector) ||
      (this.externalEls.trigger &&
        e.target.closest(this.externalEls.trigger.selector))
    if (!target) return

    const id = target.dataset.productId

    if (!id) return

    this.updateTabs(id)
    this.updatePanels(id)
  }

  updateTabs (id) {
    this.tabs.forEach(tab => {
      tab.setAttribute('aria-pressed', tab.dataset.productId === id)
    })
  }

  updatePanels (id) {
    this.panels.forEach(panel => {
      panel.setAttribute('aria-hidden', panel.dataset.productId !== id)
    })
  }
}

if (!customElements.get('complete-the-style-tabs')) {
  customElements.define('complete-the-style-tabs', CompleteTheStyleTabs)
}
